/* eslint-disable no-useless-escape */
import emojiRegex from 'emoji-regex'

const NO_LOGO_PATH = '/static/img/others/no_logo.png'

export default {
  data () {
    return {
      screenWidth: window.innerWidth,
      noLogo: {
        path: NO_LOGO_PATH,
        url: `${process.env.APP_URL}${NO_LOGO_PATH}`
      }
    }
  },
  computed: {
    deviceType () {
      if (this.baseIsMobile) {
        return 'mobile'
      }
      if (this.baseIsTablet) {
        return 'tablet'
      }
      if (this.baseIsDesktop) {
        return 'desktop'
      }
    },
    baseIsMobile () {
      return this.screenWidth < 768
    },
    isMobile () {
      return this.baseIsMobile
    },
    baseIsDesktop () {
      return this.screenWidth >= 1200
    },
    isDesktop () {
      return this.baseIsDesktop
    },
    baseIsTablet () {
      return this.screenWidth >= 768 && this.screenWidth < 1200
    },
    isTablet () {
      return this.baseIsTablet
    }
  },
  methods: {
    /**
     * Check that given sentence has at least 10 words in it.
     * @param {string} sentence Sentence to check
     * @returns {boolean}
     */
    hasAtLeastTenWords (sentence) {
      const regexEmoji = emojiRegex()
      sentence = sentence.replace(regexEmoji, '') // Remove emojis
      sentence = sentence.replace(/[!@#$%^&*()_+\=\[\]{}|;:'",.<>\/?]/g, '') // Remove special characters

      // trim() removes leading/trailing whitespace.
      // split(/\s+/) splits the sentence into words based on one or more whitespace characters.
      const wordCount = sentence.trim().split(/\s+/).length
      return wordCount >= 10
    },
    /**
     * Check that given input is not empty
     * @param {string} input Input to check
     * @returns {boolean}
     */
    isNotEmpty (input) {
      input = input.trim()
      return input.length > 0
    },
    minutesToHours (minutes) {
      minutes = Number(minutes)
      if (minutes) {
        const hours = Math.floor(minutes / 60)
        minutes = Math.floor(minutes % 60)

        return hours + '.' + minutes
      }
      return 0
    },
    twitter_share_text ({author, bizName, rating, consumerCompetitions}) {
      let twitterText = encodeURIComponent(`${author} gave ${bizName} ${rating} star${rating > 1 ? 's' : ''} via @hellopetercom`)
      if (consumerCompetitions.includes('20k')) {
        twitterText = 'WIN%20R20%2C000%20by%20Giving%20a%20Business%20Their%20First%20Hellopeter%20Review.%2012%20months.%2012%20chances%20to%20win.%20T%26CS%20apply.%20Check%20out%20my%20review%3A%20'
      }
      return twitterText
    },
    pluralize (word, count) {
      return count > 1 ? word + 's' : word
    },
    trimText (text, lengthAllowed) {
      if (text.length > lengthAllowed) {
        const suffix = '...'
        return text.substring(0, lengthAllowed - suffix.length) + suffix
      }
      return text
    },
    bizLogo (url) {
      return url || this.noLogo.path
    },
    npsScore (npsBucket) {
      let totalRespondents = 0
      let promoters = 0
      let detractors = 0

      npsBucket.forEach(bucket => {
        const npsScore = parseInt(bucket.key, 10)
        if (npsScore < 7) {
          detractors += bucket.doc_count
        }
        if (npsScore > 8) {
          promoters += bucket.doc_count
        }
        totalRespondents += bucket.doc_count
      })
      return totalRespondents > 0 ? Math.floor(((promoters - detractors) / totalRespondents) * 100) : 0
    },
    npsRecommendation (npsScore) {
      if (npsScore < 1) {
        return 'Unlikely'
      }

      if (npsScore >= 1 && npsScore <= 49) {
        return 'Likely'
      }

      return 'Very Likely'
    },
    npsCat (npsScore) {
      if (npsScore === null || typeof npsScore === 'undefined') {
        return ''
      }

      if (npsScore >= 0 && npsScore < 7) {
        return 'detractors'
      } else if (npsScore > 6 && npsScore < 9) {
        return 'passives'
      } else if (npsScore > 8 && npsScore <= 10) {
        return 'promoters'
      }
    },
    /**
     * Recache website page
     *
     * @param {string} url Page URL to recache
     * @returns {void}
     */
    recache (url = '') {
      /* url = process.env.APP_URL + url
      axios.post('https://api.prerender.io/recache', {
        prerenderToken: process.env.PRERENDER_TOKEN,
        url: url
      }) */
    },
    /**
     * Recache review detail page
     *
     * @param {string} bizSlug Business slug
     * @param {string} permalink Review permalink
     * @returns {void}
     */
    recacheReviewDetail (bizSlug, permalink) {
      this.recache(`/${bizSlug}/reviews/${permalink}`) // Review detail page
    },
    /**
     * Convert given string to snake case
     *
     * @param {string} str String to convert
     * @returns {string}
     */
    toSnakeCase (str) {
      return str &&
        str
          .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
          .map(x => x.toLowerCase())
          .join('_')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/misc.js